import { theme } from "components/lib/utils/theme";

export const PasswordRequirementStyles = {
  fontSize: theme.fontSizes[2],
  color: theme.colors.grey.text,
};
